const API_ROOT = "https://api.ehealth4cancer.eu";
// const API_ROOT = "http://localhost:8000/api";

const API_ENDPOINTS = {
  PEOPLE: `${API_ROOT}/people/`,
  PEOPLE_INFORMATION: `${API_ROOT}/person-info/`,
  TAGS: `${API_ROOT}/tags/`,
  SOCIAL_LINKS: `${API_ROOT}/social-links/`,
};

export default API_ENDPOINTS;
